module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-material-design-for-bootstrap","short_name":"MDB starter","start_url":"/","background_color":"#4B5EB8","theme_color":"#68008C","display":"standalone","icon":"/home/audiobuzz/src/gitlab.com/amanda-net-au/BaseSite/amanda-net-au/src/images/mdb-react-small.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"faf2e494c2db0f4140a76042f8e85a13"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
